import { QueryClient } from '@tanstack/react-query'

import type { MutationQueueItem } from './db'

const MACHINE_LISTS: Partial<Record<MutationQueueItem['entity'], readonly (readonly string[])[]>> = {
  geoRehandle: [['geology', 'rehandleDiggers'], ['geology', 'crushingLoaders'], ['geology', 'rehandleTrucks']],
  loading: [['geology', 'productionTrucks']],
  diggingPattern: [['chatree', 'plants']],
}

export async function refreshMachineLists(queryClient: QueryClient, entity: MutationQueueItem['entity']) {
  for (const queryKey of MACHINE_LISTS[entity] ?? [])
    await queryClient.invalidateQueries({ queryKey })
}
